import Moment from 'moment';
import { actions } from 'react-redux-form';
import {
    userCostAllocationFormModel,
    userCostAllocationTableFormModel,
    getUserCostAllocation,
    addUserCostAllocationDetails,
    updateUserCostAllocationItem,
    deleteUserCostAllocationDetails,
    getGLCodeList,
    getCostCodeList,
    setCostCodeLoading,
    setGlCodeLoading,
    getCostCodeDetailsList,
    resetCostAllocation
} from '../../../../constants/model-reducers/external/manage-user/form/user-cost-allocation.settings';
import { httpGet } from '../../../../utils/api.utils';
import { convertToTimeZoneDate } from "../../../../utils/helpers.utils";

export const userCostAllocationFormInitialState = userCostAllocationFormModel;
export const userCostAllocationTableFormInitialState = userCostAllocationTableFormModel

const defaultState = () => ({
    userCostAllocation: {
        datatable: [],
        totalCostCodePercent: 0
    },
    glCodeList: [],
    costCodeList: [],
    glCodeTableOption: [],
    costCodeTableOption: [],
    costCodeDetailsOptions: [],
    costCodeRefId: 0,
    costCodePage: 1,
    isCostCodeLoading: false,
    hasMoreCostCode: true,
    glCodePage: 1,
    isGlCodeLoading: false,
    hasMoreGlCode: true,
    limitRenderCostCode: 1,
    limitRenderGlCode: 1
});

const initialState = defaultState();

export const userCostAllocationActions = {
    getAddCostAllocation: (userId) => async (dispatch, state) => {
        var userCostAllocation = await httpGet('external/manageUser/getUserCostAllocation/' + userId);

        dispatch({
            type: getUserCostAllocation,
            userCostAllocation: userCostAllocation
        });
    },
    addCostAllocationDetails: (data, totalCostCodePercent) => async (dispatch, state) => {
        const { manageUserCostAllocationForm } = state().form;
        const { datatable } = state().manageUserCostAllocation.userCostAllocation;
        var lastModified = data.LastModified;;
        var userGlCodeList = await httpGet('external/autosuggest/getGLCodeDetailsForCircuitDetails/' + sessionStorage.EmployeeID + '?val=' + data.GLCode);
        var usercostCodeList = await httpGet('external/autosuggest/getCostCenterDetails/' + sessionStorage.EmployeeID +
            '?val=' + data.CostCode + '&companycode=' + manageUserCostAllocationForm.CompanyCode);


        var glCodeName = '';
        var glCodeId = '';
        var glCode = '';
        if (userGlCodeList.length > 0) {
            glCodeName = userGlCodeList[0].Name;
            glCodeId = userGlCodeList[0].GlcodeId;
            glCode = userGlCodeList[0].Glcode;
        }

        var companyCode = manageUserCostAllocationForm.CompanyCode;
        var costCodeId = '';
        var costCode = '';
        if (usercostCodeList.length > 0) {
            costCodeId = usercostCodeList[0].CostCodeId;
            costCode = usercostCodeList[0].CostCenter;
        }

        var dataItem = datatable[0].dataItem
        var HeaderItem = datatable[0].HeaderItem

        var newCostAllocation = [
            ...dataItem,
            {
                ...userCostAllocationFormModel,
                CostCodeID: costCodeId,
                CostCode: costCode,
                CompanyCode: companyCode,
                GLCodeID: glCodeId,
                GLCode: glCode,
                GLCodeName: glCodeName,
                CostCodePercent: parseFloat(data.CostCodePercent),
                LastModified: lastModified
            }
        ];

        var newDataTable = [{
            dataItem: newCostAllocation,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: addUserCostAllocationDetails,
            datatable: newDataTable,
            totalCostCodePercent: totalCostCodePercent
        })
    },
    updateUserCostAllocationItem: (indexItem) => async (dispatch, state) => {
        const { datatable } = state().manageUserCostAllocation.userCostAllocation;
        const { manageUserCostAllocationTableForm } = state().form;
        const { activeTimeZoneOffset } = state().adminSetting;

        const { glCodeTableOption, costCodeTableOption } = state().manageUserCostAllocation

        const updatedGlCode = glCodeTableOption[0];
        const updateCostCode = costCodeTableOption[0];

        var glCodeName = '';
        var glCodeId = '';
        var glCode = '';
        if (updatedGlCode) {
            glCodeName = updatedGlCode.Label;
            glCodeId = updatedGlCode.Key;
            glCode = updatedGlCode.Value;
        }

        var companyCode = '';
        var costCodeId = '';
        var costCode = '';

        if (updateCostCode) {
            costCodeId = updateCostCode.Key;
            costCode = updateCostCode.Value;
            companyCode = updateCostCode.Label;
        }

        var dataItem = datatable[0].dataItem
        var HeaderItem = datatable[0].HeaderItem

        var lastModified = sessionStorage.FirstName + ' ' + sessionStorage.LastName + ' ' + 'on' + ' '
            + Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('L').toString() + ' '
            + Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('LT');


        dataItem[indexItem] = {
            ...manageUserCostAllocationTableForm,
            CostAllocationID: dataItem[indexItem].CostAllocationID,
            CostCodePercent: parseFloat(manageUserCostAllocationTableForm.CostCodePercent),
            GLCodeName: glCodeName,
            GLCodeID: glCodeId,
            GLCode: glCode,
            CostCodeID: costCodeId,
            CompanyCode: companyCode,
            CostCode: costCode,
            LastModified: lastModified,
        };

        var totalCostCodePercent = 0;
        totalCostCodePercent = dataItem.reduce(
            (total, item) => total + parseFloat(item.CostCodePercent),
            0
        );

        var newDataTable = [{
            dataItem: dataItem,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: updateUserCostAllocationItem,
            datatable: newDataTable,
            totalCostCodePercent: totalCostCodePercent
        });
    },
    deleteCostAllocationDetails: (index) => (dispatch, state) => {
        const { datatable } = state().manageUserCostAllocation.userCostAllocation;

        var dataItem = datatable[0].dataItem
        var HeaderItem = datatable[0].HeaderItem

        var newDataItem = [...dataItem]
        newDataItem.splice(index, 1)
        var newCostAllocationList = newDataItem


        var totalCostCodePercent = 0;
        totalCostCodePercent = newDataItem.reduce(
            (total, item) => total + parseFloat(item.CostCodePercent),
            0
        );


        var newDataTable = [{
            dataItem: newCostAllocationList,
            HeaderItem: HeaderItem,
        }]

        dispatch({
            type: deleteUserCostAllocationDetails,
            datatable: newDataTable,
            totalCostCodePercent: totalCostCodePercent
        });
    },

    getCostCodeDetailList: (pageIndex = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;
        let modifySearchString = searchString;

        if (searchString?.includes("~") && searchString != null) {
            modifySearchString = searchString.split("~")[0].trim();
        }
        
        dispatch({
            type: setCostCodeLoading,
            payload: true
        });

        try {
            let url = `external/autosuggest/getCostCodes/${pageIndex}/${pageSize}`;

            if (searchString) {
                url += `/${encodeURIComponent(modifySearchString)}`;
            }
            var costCodeList = await httpGet(url);

            if (costCodeList != null) {
                dispatch({
                    type: getCostCodeDetailsList,
                    costCodeList: costCodeList ? costCodeList : []
                    , costCodeListPage: pageIndex
                });

                return costCodeList;

            } else {
                return null
            }
        }
        catch (e) {
            return null;
        } finally {
            dispatch({
                type: setCostCodeLoading,
                payload: false
            });
        }
    },

    getGlCodeList: (pageIndex = 1, searchString = '', glCodeFromTable = false, limitRender = 1) => async (dispatch, state) => {
        const { glCodeList, glCodeTableOption } = state().manageUserCostAllocation;
        const pageSize = 15;

        dispatch({
            type: setGlCodeLoading,
            payload: true
        });

        try {
            let url = `external/autosuggest/getGLCodes/${pageIndex}/${pageSize}`;

            if (searchString) {
                url += `/${encodeURIComponent(searchString)}`;
            }

            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getGLCodeList,
                    payload: {
                        glCode: !glCodeFromTable ? res : glCodeList,
                        glCodeTableOption: glCodeFromTable ? res : glCodeTableOption,
                        glCodeFromTable,
                        glCodePage: pageIndex,
                        limitRenderGlCode: limitRender + 1
                    }
                });
                return res;
            } else {
                return null;
            }
        } catch (e) {
            return null;
        } finally {
            dispatch({
                type: setGlCodeLoading,
                payload: false,
                limitRenderGlCode: 1
            });
        }
    },

    getCostCodeList: (pageIndex = 1, searchString = '', costCodeFromTable = false, limitRender = 1) => async (dispatch, state) => {
        const pageSize = 15;
        const { costCodeList, costCodeTableOption } = state().manageUserCostAllocation;

        dispatch({
            type: setCostCodeLoading,
            payload: true
        });

        try {
            let url = `external/autosuggest/getCostCodes/${pageIndex}/${pageSize}`;

            if (searchString) {
                url += `/${encodeURIComponent(searchString)}`;
            }
            var costCode = await httpGet(url);

            if (costCode != null) {
                dispatch({
                    type: getCostCodeList,
                    payload: {
                        costCode: !costCodeFromTable ? costCode : costCodeList
                        , costCodeTableOption: costCodeFromTable ? costCode : costCodeTableOption
                        , costCodePage: pageIndex
                        , limitRenderCostCode: limitRender + 1
                        , costCodeFromTable
                    }
                });

                return costCode;

            } else {
                return null
            }
        }
        catch (e) {
            return null;
        } finally {
            dispatch({
                type: setCostCodeLoading,
                payload: false,
                limitRenderCostCode: 1
            });
        }
    },

    resetCostAllocation: () => (dispatch) => {
        dispatch(actions.reset("manageUserCostAllocationForm"));
        dispatch(actions.reset("manageUserCostAllocationForm.CompanyCode"));
        dispatch(actions.reset('manageUserCostAllocationForm.CostCenter'));
        dispatch(actions.reset('manageUserCostAllocationForm.GLCode'));
        dispatch(actions.change("manageUserCostAllocationForm.CompanyCode", ''));
        dispatch(actions.change('manageUserCostAllocationForm.CostCenter', ''));
        dispatch(actions.change('manageUserCostAllocationForm.GLCode', ''));
        dispatch({
            type: resetCostAllocation
        });
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getUserCostAllocation:
            return {
                ...state,
                userCostAllocation: action.userCostAllocation,
            };
        case addUserCostAllocationDetails:
            return {
                ...state,
                userCostAllocation: {
                    ...state.userCostAllocation,
                    datatable: action.datatable,
                    totalCostCodePercent: action.totalCostCodePercent
                },
            };
        case deleteUserCostAllocationDetails:
            return {
                ...state,
                userCostAllocation: {
                    ...state.userCostAllocation,
                    datatable: action.datatable,
                    totalCostCodePercent: action.totalCostCodePercent
                },
            };
        case updateUserCostAllocationItem:
            return {
                ...state,
                userCostAllocation: {
                    ...state.userCostAllocation,
                    datatable: action.datatable,
                    totalCostCodePercent: action.totalCostCodePercent
                }
            };
        case getGLCodeList:
            const { glCode, glCodePage, glCodeTableOption, glCodeFromTable, limitRenderGlCode } = action.payload;
            const newGlCodeList = Array.isArray(glCode) ? glCode : [];
            const newGlCodeTableList = Array.isArray(glCodeTableOption) ? glCodeTableOption : [];

            return {
                ...state,
                glCodeList: !glCodeFromTable ? glCodePage === 1
                    ? newGlCodeList
                    : [...state.glCodeList, ...newGlCodeList] : glCode,
                glCodeTableOption: glCodeFromTable ? glCodePage === 1
                    ? newGlCodeTableList
                    : [...state.glCodeTableOption, ...newGlCodeTableList] : glCodeTableOption,
                glCodePage,
                hasMoreGlCode: glCodeFromTable ? newGlCodeTableList.length > 0 : newGlCodeList.length > 0,
                limitRenderGlCode: limitRenderGlCode
            };
        case getCostCodeList:
            const { costCode, costCodePage, costCodeTableOption, limitRenderCostCode, costCodeFromTable } = action.payload;
            const newCostCodeList = Array.isArray(costCode) ? costCode : [];
            const newCostCodeTableList = Array.isArray(costCodeTableOption) ? costCodeTableOption : [];

            return {
                ...state,
                costCodeList: costCodePage === 1
                    ? newCostCodeList
                    : [...state.costCodeList, ...newCostCodeList],
                costCodeTableOption: costCodePage === 1
                    ? newCostCodeTableList
                    : [...state.costCodeTableOption, ...newCostCodeTableList],
                costCodePage,
                hasMoreCostCode: costCodeFromTable ? newCostCodeTableList.length > 0 : newCostCodeList.length > 0,
                limitRenderCostCode: limitRenderCostCode
            };
        case getCostCodeDetailsList:
            const { costCodeList, costCodeListPage } = action;
            const newCostCodeDetailsList = Array.isArray(costCodeList) ? costCodeList : [];
            return {
                ...state,
                costCodeDetailsOptions: costCodeListPage === 1
                    ? newCostCodeDetailsList
                    : [...state.costCodeDetailsOptions, ...newCostCodeDetailsList],
                costCodePage: costCodeListPage
            }
        case setCostCodeLoading:
            return {
                ...state,
                isCostCodeLoading: action.payload,
                limitRenderCostCode: action.limitRenderCostCode
            }
        case setGlCodeLoading:
            return {
                ...state,
                isGlCodeLoading: action.payload,
                limitRenderGlCode: action.limitRenderGlCode
            }
        case resetCostAllocation: 
            return {
                ...state,
                costCodeDetailsOptions: []
            }
        default:
            return state;
    }

};